module.exports = __webpack_public_path__ + "img/22.5da6a199.png";